/* eslint-disable no-uncheck-object-value-in-if */
import React from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { withStyles } from "material-ui/styles";
import Loader from '../../../Parts/Loader';
import DialogModal from '../../../common/DialogModal';
import Header from "./sections/Header";
import KeymanReferenceLink from './parts/KeymanReferenceLink';
import KeymanProfile from './parts/KeymanProfile';
import RecommendRankingAndReactionTags from './parts/RecommendRankingAndReactionTags';
import DepartmentSection from './sections/DepartmentSection';
import FunctionButtons from './parts/FunctionButtons';
import LetterSendCount from "./sections/LetterSendCount";
import KeymanBiographies from "./sections/KeymanBiographies";
import KeymanCallMemos from "./sections/KeymanCallMemos";
import CompanyInfo from "./sections/CompanyInfo";
import CompanyProfile from "./parts/CompanyProfile";
import CompanyFinancialStatement from "./parts/CompanyFinancialStatement";
import CompanyBasicInfo from "./parts/CompanyBasicInfo";
import SameDepartmentIncludeParentAndChildCorporationKeymanList from './sections/SameDepartmentIncludeParentAndChildCorporationKeymanList';
import ParentCorporationKeymanList from './sections/ParentCorporationKeymanList';
import ChildCorporationKeymanList from './sections/ChildCorporationKeymanList';
import RivalCompanyKeymans from './sections/RivalCompanyKeymans';
import Footer from './sections/Footer';
import { isEnableReactionKeyword } from '../../../../utils/userUtils';
import { createCorporationKeymanSearchParams } from '../../../../utils/executiveListUtils';
import { postExecutiveListSearchRival, postExecutiveListSearchParentCorporationKeymanList, postExecutiveListSearchChildCorporationKeymanList, postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanList } from '../../../../redux/actions/ExecutiveList';
import { getTimelineStatus } from '../../../../redux/actions/Timeline';

const styles = () => ({
  contentContainer: {
    width: '600px',
    margin: 0,
    display: "flex",
    padding: 0,
    flexDirection: "column",
    boxSizing: "border-box",
    background: "#FFFFFF",
    textAlign: "left",
  },

  content: {
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    borderTop: '1px solid #D8DBDF',
    justifyContent:'space-between',
  },

  emptyContainer: {
    height: '1000px',
    background: "#FFFFFF",
  },

  vertical: {
    display: 'flex',
    flexDirection: 'unset',
    alignItems: 'flex-start',
    width: '100%',
    justifyContent: 'space-between'
  },
});

class ExecDetailItemDialog extends React.Component {
  componentDidMount = () => {
    // タイムラインのページ用
    if (this.props.executiveListItem && this.props.executiveListItem.executive_person_id) {
      this.props.getTimelineStatus(this.props.executiveListItem.executive_person_id, {
        "executive_person_id": this.props.executiveListItem.executive_person_id,
        "with_letter_order": true,
        "with_follow_order": true,
      });
      this.props.postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanList(this.props.executiveListItem.id,
        {
          "department": this.props.executiveListItem.department_keys,
          ...createCorporationKeymanSearchParams(Array.from(new Set([...[this.props.executiveListItem.corporation_id],...this.props.executiveListItem.parent_corporation_ids, ...this.props.executiveListItem.child_corporation_ids])), "include_parent_and_child_corporation_ids")
        }
      );
      this.props.postExecutiveListSearchParentCorporationKeymanList(this.props.executiveListItem.id,
        createCorporationKeymanSearchParams(this.props.executiveListItem.parent_corporation_ids, "parent_corporation_ids")
      );
      this.props.postExecutiveListSearchChildCorporationKeymanList(this.props.executiveListItem.id,
        createCorporationKeymanSearchParams(this.props.executiveListItem.child_corporation_ids, "child_corporation_ids")
      );
      this.props.postExecutiveListSearchRival(this.props.executiveListItem.id,
        createCorporationKeymanSearchParams(this.props.executiveListItem.shikiho_rival_companies, "corporation_id")
      );
    }
  };

  componentDidUpdate = (prevProps) => {
    // キーマンデータベースページ用
    window.scrollTo(0, 0)

    if (
      (!prevProps.executiveListItem && this.props.executiveListItem && this.props.executiveListItem.id) // 初回ロード
      ||
      (this.props.executiveListItem && prevProps.executiveListItem && this.props.executiveListItem.id !== prevProps.executiveListItem.id) // ロード後の更新
    ) {
      this.props.getTimelineStatus(this.props.executiveListItem.executive_person_id, {
        "executive_person_id": this.props.executiveListItem.executive_person_id,
        "with_letter_order": true,
        "with_follow_order": true,
      });
      this.props.postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanList(this.props.executiveListItem.id,
        {
          "department": this.props.executiveListItem.department_keys,
          ...createCorporationKeymanSearchParams(Array.from(new Set([...[this.props.executiveListItem.corporation_id],...this.props.executiveListItem.parent_corporation_ids, ...this.props.executiveListItem.child_corporation_ids])), "include_parent_and_child_corporation_ids")
        }
      );
      this.props.postExecutiveListSearchParentCorporationKeymanList(this.props.executiveListItem.id,
        createCorporationKeymanSearchParams(this.props.executiveListItem.parent_corporation_ids, "parent_corporation_ids")
      );
      this.props.postExecutiveListSearchChildCorporationKeymanList(this.props.executiveListItem.id,
        createCorporationKeymanSearchParams(this.props.executiveListItem.child_corporation_ids, "child_corporation_ids")
      );
      this.props.postExecutiveListSearchRival(this.props.executiveListItem.id,
        createCorporationKeymanSearchParams(this.props.executiveListItem.shikiho_rival_companies, "corporation_id")
      );
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <DialogModal
        open={this.props.isOpen}
        onClose={this.props.toggleDialog}
        maxWidth={false}
        classes={{ contentContainer: classes.contentContainer }}
      >
      {(() => {
        if (this.props.isLoadingExecutiveListItem) {
          return (
            <div className={classes.emptyContainer}>
              <Loader type="color" size="large" width={200} />
            </div>
          );
        } else {
          return (
            <div className={classes.content}>
              <Header>
                <div className={classes.vertical}>
                  <KeymanProfile item={this.props.executiveListItem}>
                    {Boolean(isEnableReactionKeyword(this.props.user)) && (
                      <RecommendRankingAndReactionTags
                        item={this.props.executiveListItem}
                        filterIntentKeywords={this.props.filterIntentKeywords}
                      />
                    )}
                  </KeymanProfile>
                  <FunctionButtons
                    user={this.props.user}
                    item={this.props.executiveListItem}
                    enableExecutiveListAdvancedSearch={this.props.enableExecutiveListAdvancedSearch}
                    toggleDialog={this.props.toggleDialog}
                    toggleEditTagsDialog={this.props.toggleEditTagsDialog}
                    toggleCsvDownloadDialog={this.props.toggleCsvDownloadDialog}
                    goToSendLetter={this.props.goToSendLetter} />
                </div>
                <KeymanReferenceLink item={this.props.executiveListItem} />
              </Header>
              <DepartmentSection executiveListItem={this.props.executiveListItem} enableExecutiveListAdvancedSearch={this.props.enableExecutiveListAdvancedSearch}/>
              <KeymanCallMemos item={this.props.executiveListItem} />
              <LetterSendCount statuses={this.props.statuses} goToTimeline={this.props.goToTimeline}/>
              <KeymanBiographies item={this.props.executiveListItem} />
              <CompanyInfo item={this.props.executiveListItem}>
                <CompanyProfile item={this.props.executiveListItem}/>
                <CompanyFinancialStatement item={this.props.executiveListItem}/>
                <CompanyBasicInfo item={this.props.executiveListItem} user={this.props.user} togglePromotePlanChangeDialog={this.props.togglePromotePlanChangeDialog}/>
              </CompanyInfo>
              <SameDepartmentIncludeParentAndChildCorporationKeymanList
                isLoading={this.props.isLoadingSameDepartmentIncludeParentAndChildCorporationKeymanList}
                list={this.props.sameDepartmentIncludeParentAndChildCorporationKeymanList}
                total={this.props.sameDepartmentIncludeParentAndChildCorporationKeymanListTotal}
                handleFilter={this.props.handleFilterSameDepartmentIncludeParentAndChildCorporationKeyman}
                toggleDialog={this.props.toggleDialog}
              />
              <ParentCorporationKeymanList
                isLoading={this.props.isLoadingParentCorporationKeymanList}
                list={this.props.parentCorporationKeymanList}
                total={this.props.parentCorporationKeymanListTotal}
                handleFilter={this.props.handleFilterParentCorporationKeyman}
                toggleDialog={this.props.toggleDialog}
              />
              <ChildCorporationKeymanList
                isLoading={this.props.isLoadingChildCorporationKeymanList}
                list={this.props.childCorporationKeymanList}
                total={this.props.childCorporationKeymanListTotal}
                handleFilter={this.props.handleFilterChildCorporationKeyman}
                toggleDialog={this.props.toggleDialog}
              />
              <RivalCompanyKeymans
                isLoading={this.props.isLoadingRival}
                list={this.props.rivalExecList}
                total={this.props.rivalTotal}
                handleFilter={this.props.handleFilterRivalKeyman}
                toggleDialog={this.props.toggleDialog}
              />
              <Footer
                user={this.props.user}
                enableExecutiveListAdvancedSearch={this.props.enableExecutiveListAdvancedSearch}
                toggleDialog={this.props.toggleDialog}
                toggleEditTagsDialog={this.props.toggleEditTagsDialog}
                toggleCsvDownloadDialog={this.props.toggleCsvDownloadDialog}
                goToSendLetter={this.props.goToSendLetter}
              />
            </div>
          );
        }
      })()}
      </DialogModal>
    );
  }
}

ExecDetailItemDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  isOpen: PropTypes.bool,
  enableExecutiveListAdvancedSearch: PropTypes.bool,
  toggleDialog: PropTypes.func.isRequired,
  toggleEditTagsDialog: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  togglePromotePlanChangeDialog: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  goToSendLetter: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  // executivePersonProps
  isLoadingExecutiveListItem: PropTypes.bool,
  executiveListItem: PropTypes.object,
  filterIntentKeywords: PropTypes.array,
  // timelineProps
  statuses: PropTypes.array,
  getTimelineStatus: PropTypes.func,
  goToTimeline: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  // corporationRelationshipsKeymanProps(rival)
  isLoadingRival: PropTypes.bool,
  rivalExecList: PropTypes.array,
  rivalTotal: PropTypes.number,
  handleFilterRivalKeyman: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  postExecutiveListSearchRival: PropTypes.func,
  // corporationRelationshipsKeymanProps(sameDepartmentIncludeParentAndChildCorporation)
  isLoadingSameDepartmentIncludeParentAndChildCorporationKeymanList: PropTypes.bool,
  sameDepartmentIncludeParentAndChildCorporationKeymanList: PropTypes.array,
  sameDepartmentIncludeParentAndChildCorporationKeymanListTotal: PropTypes.number,
  handleFilterSameDepartmentIncludeParentAndChildCorporationKeyman: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanList: PropTypes.func,
  // corporationRelationshipsKeymanProps(parent)
  isLoadingParentCorporationKeymanList: PropTypes.bool,
  parentCorporationKeymanList: PropTypes.array,
  parentCorporationKeymanListTotal: PropTypes.number,
  handleFilterParentCorporationKeyman: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  postExecutiveListSearchParentCorporationKeymanList: PropTypes.func,
  // corporationRelationshipsKeymanProps(child)
  isLoadingChildCorporationKeymanList: PropTypes.bool,
  childCorporationKeymanList: PropTypes.array,
  childCorporationKeymanListTotal: PropTypes.number,
  handleFilterChildCorporationKeyman: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  postExecutiveListSearchChildCorporationKeymanList: PropTypes.func,
  // csvProps
  toggleCsvDownloadDialog: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
};

ExecDetailItemDialog.defaultProps = {
  toggleEditTagsDialog: null,
  goToSendLetter: null,
  // executivePersonProps
  goToTimeline: null,
  // corporationRelationshipsKeymanProps(rival)
  isLoadingRival: false,
  rivalExecList: [],
  rivalTotal: 0,
  handleFilterRivalKeyman: null,
  // corporationRelationshipsKeymanProps(sameDepartmentIncludeParentAndChildCorporation)
  isLoadingSameDepartmentIncludeParentAndChildCorporationKeymanList: false,
  sameDepartmentIncludeParentAndChildCorporationKeymanList: [],
  sameDepartmentIncludeParentAndChildCorporationKeymanListTotal: 0,
  handleFilterSameDepartmentIncludeParentAndChildCorporationKeyman: null,
  // corporationRelationshipsKeymanProps(parent)
  isLoadingParentCorporationKeymanList: false,
  parentCorporationKeymanList: [],
  parentCorporationKeymanListTotal: 0,
  handleFilterParentCorporationKeyman: null,
  // corporationRelationshipsKeymanProps(child)
  isLoadingChildCorporationKeymanList: false,
  childCorporationKeymanList: [],
  childCorporationKeymanListTotal: 0,
  handleFilterChildCorporationKeyman: null,
  // csvProps
  toggleCsvDownloadDialog: null,
};

const mapStateToProps = (state) => {
  return {
    rivalExecList: state.executiveDetail.rivalExecList,
    isLoadingRival: state.executiveDetail.isLoadingRival,
    rivalTotal: state.executiveDetail.rivalTotal,
    statuses: state.timeline.statuses.toIndexedSeq().toArray(),
    isLoadingStatuses: state.timeline.isLoadingStatuses,
    sameDepartmentIncludeParentAndChildCorporationKeymanList: state.executiveDetail.sameDepartmentIncludeParentAndChildCorporationKeymanList,
    isLoadingSameDepartmentIncludeParentAndChildCorporationKeymanList: state.executiveDetail.isLoadingSameDepartmentIncludeParentAndChildCorporationKeymanList,
    sameDepartmentIncludeParentAndChildCorporationKeymanListTotal: state.executiveDetail.sameDepartmentIncludeParentAndChildCorporationKeymanListTotal,
    parentCorporationKeymanList: state.executiveDetail.parentCorporationKeymanList,
    isLoadingParentCorporationKeymanList: state.executiveDetail.isLoadingParentCorporationKeymanList,
    parentCorporationKeymanListTotal: state.executiveDetail.parentCorporationKeymanListTotal,
    childCorporationKeymanList: state.executiveDetail.childCorporationKeymanList,
    isLoadingChildCorporationKeymanList: state.executiveDetail.isLoadingChildCorporationKeymanList,
    childCorporationKeymanListTotal: state.executiveDetail.childCorporationKeymanListTotal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTimelineStatus: (id, data) => {
      dispatch(getTimelineStatus(id, data));
    },
    postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanList: (id, data) => {
      dispatch(postExecutiveListSearchSameDepartmentIncludeParentAndChildCorporationKeymanList(id, data));
    },
    postExecutiveListSearchParentCorporationKeymanList: (id, data) => {
      dispatch(postExecutiveListSearchParentCorporationKeymanList(id, data));
    },
    postExecutiveListSearchChildCorporationKeymanList: (id, data) => {
      dispatch(postExecutiveListSearchChildCorporationKeymanList(id, data));
    },
    postExecutiveListSearchRival: (id, data) => {
      dispatch(postExecutiveListSearchRival(id, data));
    },

  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(ExecDetailItemDialog));



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/ExecDetailItemDialog.jsx